import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

import { format } from 'date-fns'

import { License } from '../../../types'

export const collection = 'licenses'

export const schema = new schemas.Entity(
  collection,
  {},
  { idAttribute: (license) => compositeId(license) }
)

export const compositeId = (license: License) => {
  let id = ''

  if (license.isGenerator) {
    id = '+'
  }

  id += license.type

  if (license.packages) {
    id += `;${license.packages.join('+')}`
  }

  if (license.expirationDate) {
    id += `;${format(new Date(license.expirationDate), 'dd-M-yyyy')}`
  }

  return id
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: { id: string }) =>
    callApi(`${apiBase}/info/licenses/${id}`, schema)
